export default [
  {
    path: 'admin',
    name: 'admin',
    component: () => import(/* webpackChunkName: "admin" */ '@/components/admin/Permissions'),
    meta: { title: 'Admin', permission: 'admin' }
  }
]
